/* eslint-disable react-hooks/exhaustive-deps */
import GroupRadioButton from 'components/input/GroupRadioButton';
import SelectInput from 'components/input/SelectInput';
import SearchIcon from '@mui/icons-material/Search';
import RemoveIcon from '@mui/icons-material/Remove';
import { Typeahead } from 'react-bootstrap-typeahead';
import React from 'react';
import CheckboxInput from 'components/input/CheckboxInput';
import TextInput from 'components/input/textInput';
import SelectSearchInput from 'components/input/SelectSearchInput';
// import { Col, Row } from 'react-bootstrap';
import { states_usa } from 'components/helper/state_usa';
import { csuCountry, notUsCountry, highSchoolType } from 'components/helper/helper';
import courseServices from 'services/courseServices';
import axios from 'axios';
import AutocompleteInput from 'components/input/AutoCompleteInput';
import { canadaProvince, usaState } from 'components/helper/stateAndCounty';
import { debounce, defer } from 'lodash';
import Grid from '@mui/joy/Grid';
import {
  buildHighSchoolSearchLabel,
  displayHighSchoolName,
  firstSearchToken,
  highSchoolMatchesSearch,
} from '../highSchoolSearch';

export const fixHighSchoolObject = (school:any) => {
  let high_school_object: any = {
    college_board_code: '',
    school_name: '',
    school_type: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    csu_name: '',
    uc_name: '',
    cm_name: '',
    match_all: false,
    label: '',
    code: null,
    is_manual: false,
   };
   
   try {
      let isOld = false;
      if (school.hasOwnProperty('high_school_code')){
        isOld = true;
        if (school.high_school_code && school.high_school_code?.trim().length>0) {
          high_school_object.college_board_code = school.high_school_code;
          high_school_object.code = high_school_object.college_board_code;
        }
      } 
      if (school.hasOwnProperty('college_board_code')) {
        if (school.college_board_code !== null) {
          high_school_object.college_board_code = `${school.college_board_code}`;
          high_school_object.code = high_school_object.college_board_code;
        }
      }
      
      if (school.hasOwnProperty('high_school_point')) {
        isOld = true;
        if (school.high_school_point && school.high_school_point.trim().length>0) {
          if (school.high_school_point!== null) {
            high_school_object.school_name = school.high_school_point;
          }
        }
      }

      if (school.hasOwnProperty('school_name')) {
        if (school.school_name && school.school_name.trim().length>0) {
          high_school_object.school_name = school.school_name;
        }
      }

      if (school.hasOwnProperty('governance')) {
        isOld = true;
        high_school_object.school_type = school.governance;
      }
      if (school.hasOwnProperty('school_type')) {
        high_school_object.school_type = school.school_type;
      }
      if (school.hasOwnProperty('city')) {
        high_school_object.city = school.city;
      }
      if (school.hasOwnProperty('state')) {
        high_school_object.state = school.state;
      }
      if (school.hasOwnProperty('zip')) {
        high_school_object.zip = school.zip;
      }
      if (school.hasOwnProperty('country')) {
        high_school_object.country = school.country;
      }
      if (school.hasOwnProperty('csu_name')) {
        high_school_object.csu_name = school.csu_name;
      }
      else {
        isOld = true;
      }
      if (school.hasOwnProperty('uc_name')) {
        high_school_object.uc_name = school.uc_name;
      }
      else {
        isOld = true;
      }
      if (school.hasOwnProperty('cm_name')) {
        high_school_object.cm_name = school.cm_name;
      }
      else {
        isOld = true;
      }
      if (school.hasOwnProperty('match_all')) {
        high_school_object.match_all = school.match_all;
      }
      else {
        isOld = true;
      }

      if (school.hasOwnProperty('label')) {
        high_school_object.label = school.label;
      }
      if (school.hasOwnProperty('value')) {
        high_school_object.value = school.value;
      }
      if (school.hasOwnProperty('code')) {
        high_school_object.code = `${school.code}`; // force is string value

        // fix high_school_object.college_board_code is empty
        if (high_school_object.college_board_code?.trim().length===0) {
          if (school.code !== null) {
            high_school_object.college_board_code = `${school.code}`; // force is string value
          }
          //school_name
        }
      }

      if (school.hasOwnProperty('id')) {
        high_school_object.id = school.id;
      }

      if (school.hasOwnProperty('is_manual')) {
        high_school_object.is_manual = school.is_manual;
      }

      if (isOld) {
        high_school_object.is_manual = false;
      }

      return high_school_object;
   }
   catch(ex){
    console.log('Error: ', ex);
   }
   return school;
}

type MaskEditSchoolInfo = {
  college_board_code: boolean;
  school_name: boolean;
  school_type: boolean;
  city: boolean;
  state: boolean;
  zip: boolean;
  country: boolean;
}

type Props = {
  formik: any;
  isFirstSchool?: boolean;
  index: number;
  check?: any
  disabled?: boolean
};

const loadStates = () => {
  const arr = [
    { name: 'State/U.S. territory *', value: 'N/A' },
    //{ name: "Other/Unknown", value: "N/A"}
  ];
  const states = arr.concat(
    states_usa.filter((obj) => {
      return obj.value !== 'CA';
    })
  );

  return states.map((o) => {
    return o.name;
  });
};

const getStateName = (stateCode: string) => {
  for (let i = 0; i < states_usa.length; i++) {
    if (states_usa[i].value === stateCode) return states_usa[i].name;
  }
  return stateCode;
};

const getStatecode = (stateName: string) => {
  for (let i = 0; i < states_usa.length; i++) {
    if (states_usa[i].name.toLowerCase() === stateName.toLowerCase()) return states_usa[i].value;
  }
  return '';
};

const HighSchoolInfo = ( { formik, isFirstSchool, index, check, disabled } : Props) => {
  const row = index + 1;
  const getEditMask = (item: any) => {
    let mask: MaskEditSchoolInfo = {
      college_board_code: true,
      school_name: true,
      school_type: true,
      city: true,
      state: true,
      zip: true,
      country: true,
    };

    if (item) {
      if (item.hasOwnProperty('match_all')) {
        mask.college_board_code = false;
        mask.school_name = false;

        if (item.match_all) {
          mask.school_type = false;
          mask.city = false;
          mask.state = false;
          mask.zip = false;
          mask.country = false;
        }
        else {
          mask.school_type = false;
          mask.city = false;
          mask.state = false;
          mask.zip = false;
          mask.country = false;
          if (item.hasOwnProperty('college_board_code') && (item.college_board_code === null || item.college_board_code?.trim() === '')) {
            mask.college_board_code = true;
          }
          if (item.hasOwnProperty('school_type') && (item.school_type === null || item.school_type?.trim() === '')) {
            mask.school_type = true;
          }
          if (item.hasOwnProperty('city') && (item.city === null || item.city?.trim() === '')) {
            mask.city = true;
          }
          if (item.hasOwnProperty('state') && (item.state === null || item.state?.trim() === '')) {
            mask.state = true;
          }
          if (item.hasOwnProperty('zip') && (item.zip === null || item.zip?.trim() === '')) {
            mask.zip = true;
          }
          if (item.hasOwnProperty('country') &&(item.country === null || item.country?.trim() === '')) {
            mask.country = true;
          }
        }
      }
    }

    return mask;
  }

  const isNewItem = (school:any) => {
    let mask = getEditMask(school);
    return !(mask.college_board_code &&
      mask.school_name &&
      mask.school_type &&
      mask.city &&
      mask.state &&
      mask.zip &&
      mask.country) && school?.school_name === '';
  };

  const initEditMask = () => {
    return isNewItem(formik.values.high_school_object) ? {
      college_board_code: false,
      school_name: false,
      school_type: false,
      city: false,
      state: false,
      zip: false,
      country: false,
    }
      : {
        college_board_code: true,
        school_name: true,
        school_type: true,
        city: true,
        state: true,
        zip: true,
        country: true,
      };
  };
  const [highSchoolName, setHighSchoolName] = React.useState(formik.values.high_school_name)
  const [editManual, setEditManual] = React.useState(false);
  const [showNotFound, setShowNotFound] = React.useState(false);
  const [editMask, setEditMask] = React.useState<MaskEditSchoolInfo>(initEditMask());

  const [loading, setLoading] = React.useState(false);
  const typeahead = React.createRef<typeof Typeahead>();
  let searchCtrl = new AbortController();
  let states = loadStates();

  

  React.useEffect(() => {
    try {
      // let mask = getEditMask(formik.values.high_school_object);
      let isNew = isNewItem(formik.values.high_school_object);

      let school = fixHighSchoolObject(formik.values.high_school_object);
      formik.setFieldValue('high_school_object', Object.assign({},school));

      if (school) {
        if (school.is_manual) {
          setEditManual(true);
        }
        if (school.college_board_code && !school.is_manual) {
          let arr: any[] = [];
          arr.push(school);
          setHighSchoolData(arr);
          handleChangeItem(school);
          setEditMask(getEditMask(school));
        }
        else {
          if (school.is_manual) {
            setEditManual(true);
          }
        }
      }
      else {
        clearTypeHead();
      }
      
      if (isNew) {
        setEditMask({
          college_board_code: false,
          school_name: false,
          school_type: false,
          city: false,
          state: false,
          zip: false,
          country: false,
        });
        setEditManual(false);
      }
    }
    catch (ex) {
      console.log('Error:', ex);
    }
  }, []);

  const [highSchoolData, setHighSchoolData] = React.useState<any[]>([]);
  const [selectedEducation, setSelectedEducation] = React.useState<any>();

  const optionWhere = [
    { value: 'IN_CA', label: 'In California' },
    { value: 'OUTSIDE_CA', label: 'Outside California (in the U.S.)' },
    { value: 'OUTSIDE_USA', label: 'Outside the U.S.' },
  ];

  const handleGetHighSchool = async (keyword: string) => {
    if (keyword && keyword.length < 1) return;
    searchCtrl.abort();
    searchCtrl = new AbortController();

    try {
      setLoading(true);
      const searchBoard = (term: string) =>
        courseServices.searchHighSchool(
          term,
          getStatecode(formik.values.state),
          formik.values.country,
          formik.values.where_attend_high_school,
          searchCtrl
        );

      let res: any[] = (await searchBoard(keyword)) || [];
      if (!res.length) {
        const fallback = firstSearchToken(keyword);
        if (fallback && fallback.toLowerCase() !== keyword.trim().toLowerCase()) {
          const retry = (await searchBoard(fallback)) || [];
          res = retry.filter((item: any) => highSchoolMatchesSearch(item, keyword));
        }
      }

      const data = res.map((item: any) => ({
        ...item,
        label: buildHighSchoolSearchLabel(item, getStateName),
        code: item.college_board_code,
      }));

      if (res && res.length === 0) {
        setShowNotFound(true);
      }
      else {
        setShowNotFound(false);
      }

      setHighSchoolData(data);
      setLoading(false);

    } catch (error: any) {
      setLoading(false);
      if (axios.isCancel(error)) {
      } else {
        // skip
      }
    }
  };

  const handleSearchHighSchool = debounce((keyword: string) => {
    defer(() => {
      handleGetHighSchool(keyword);
    });
  }, 300);

  const clearTypeHead = () => {
    let obj: any = typeahead.current;
    obj?.clear();
  }


  const resetHighSchool = () => {
    let newValues:any = Object.assign({}, formik.values);
    newValues.high_school_object.college_board_code = '';
    newValues.high_school_object.school_name = '';
    newValues.high_school_object.school_type = '';
    newValues.high_school_object.city = '';
    newValues.high_school_object.state = '';
    newValues.high_school_object.zip = '';
    newValues.high_school_object.country = '';
    newValues.high_school_object.csu_name = '';
    newValues.high_school_object.uc_name = '';
    newValues.high_school_object.cm_name = '';
    newValues.high_school_object.match_all = false;
    newValues.high_school_object.label = '';
    newValues.high_school_object.code = null;
    newValues.high_school_name = '';
    newValues.high_school_code = '';
    newValues.csu_city = '';
    newValues.city = '';
    newValues.state = '';
    formik.setValues(newValues);
  }

  const clearManualForm = () => {
    resetHighSchool();
    setHighSchoolName('');
    setEditMask(getEditMask(null));
  }

  const checkEditMask = () => {
    return editMask.college_board_code ||
      editMask.school_name ||
      editMask.school_type ||
      editMask.city ||
      editMask.state ||
      editMask.zip ||
      editMask.country;
  }

  const handleChangeItem = (school: any) => {
    try {
      setHighSchoolData([]);
      let item: any = Object.assign({}, school);
      item.is_manual = false;                     // add is_manual to input manual or not
      item.high_school_name = item.school_name;   // add high_school_name to compatible old object. 
      setSelectedEducation(item);
      setEditMask(getEditMask(item));
      setHighSchoolName(item?.school_name);

      let newValues:any = Object.assign({}, formik.values);
      newValues.school_name =  item?.school_name;
      newValues.high_school_name =  item?.school_name;
      newValues.high_school_code =  item?.college_board_code;
      newValues.country = item?.country;
      newValues.state = getStateName(item?.state) ?? '';
      newValues.city = item?.city ?? '';
      newValues.csu_city = item?.city ?? '';
      newValues.high_school_object = item;
      formik.setValues(newValues);
      clearTypeHead();
      setEditManual(true);
    } catch (ex) {
      console.log('Error:', ex);
    }
  };

  const onChangeWhereAttend = (e: any) => {
    try {
      let data = highSchoolData;
      switch (e.target.value) {
        case 'IN_CA':
          setHighSchoolData(data);
          let newValues1:any = Object.assign({}, formik.values);
          if (formik.values.high_school_object?.state !== 'CA') {
            setSelectedEducation(undefined);
            setHighSchoolName('');
            newValues1.high_school_object = {};
            newValues1.high_school_name = '';
            newValues1.school_name = '';
            newValues1.city = '';
            newValues1.csu_city = '';            
            clearTypeHead();
            setEditManual(false);
            setShowNotFound(false);
          }

          newValues1.state = getStateName('CA');
          newValues1.country = 'United States of America';
          formik.setValues(newValues1);
          break;
        case 'OUTSIDE_CA':
          setHighSchoolData(data);
          let newValues2:any = Object.assign({}, formik.values);
          if (formik.values.high_school_object?.state === 'CA' ||
            formik.values.high_school_object?.country !== 'United States of America'
          ) {
            setSelectedEducation(undefined);
            setHighSchoolName('');
            newValues2.high_school_object = {};
            newValues2.high_school_name = '';
            newValues2.school_name = '';
            newValues2.state = '';
            newValues2.city = '';
            newValues2.csu_city = '';
            clearTypeHead();
            setEditManual(false);
            setShowNotFound(false);
          }
          newValues2.country = 'United States of America';
          formik.setValues(newValues2);
          break;
        case 'OUTSIDE_USA':
          if (formik.values.country === 'United States of America') {
            setSelectedEducation(undefined);
            let newValues3:any = Object.assign({}, formik.values);
            newValues3.high_school_object = {};
            newValues3.state = '';
            newValues3.country = '';
            formik.setValues(newValues3);
            clearTypeHead();
            setEditManual(false);
            setShowNotFound(false);
          }
          setHighSchoolData([]);
          break;
      }
      formik.handleChange(e);
      setHighSchoolData([]);
    }
    catch (ex) {
      console.log('Error: ', ex);
    }
  };

  const handleNotFound = (e: any) => {
    setEditManual(true);
    setShowNotFound(false);
    setSelectedEducation(undefined);

    resetHighSchool();


    let newValues:any = Object.assign({}, formik.values);
    newValues.high_school_object.college_board_code = '';
    newValues.high_school_object.school_type = '';
    newValues.high_school_object.city = '';
    newValues.high_school_object.state = '';
    newValues.high_school_object.zip = '';
    newValues.high_school_object.country = '';
    newValues.high_school_object.csu_name = '';
    newValues.high_school_object.uc_name = '';
    newValues.high_school_object.cm_name = '';
    newValues.high_school_object.match_all = false;
    newValues.high_school_object.label = '';
    newValues.high_school_object.code = null;
    newValues.high_school_code = '';
    newValues.csu_city = '';
    newValues.city = '';
    newValues.state = '';
    newValues.high_school_object.school_name = highSchoolName;
    newValues.high_school_name = highSchoolName;
    newValues.high_school_object.is_manual = true;
    formik.setValues(newValues);
    setEditMask(getEditMask(null));
  };

  const handleRemove = () => {
    setSelectedEducation(undefined);
    clearTypeHead();
    clearManualForm();
    setEditManual(false);
  }

  return (
    <Grid container spacing={2} className="gm-form-fields">
      {/* Where do/did you attend high school? */}
      <Grid xs={12}>
        <GroupRadioButton
          name="where_attend_high_school"
          onChange={onChangeWhereAttend}
          values={formik.values.where_attend_high_school}
          dataUp={`hs-where-attend-${row}`}
          mdCol={4}
          logo="span-uc-logo"
          label="Where do/did you attend high school?*"
          options={optionWhere}
          isMissing={!formik.values.where_attend_high_school && check}
          verticalLayout={true}
          disabled={disabled}
        />
      </Grid>

      {/* Outside CA fields */}
      {formik.values.where_attend_high_school === 'OUTSIDE_CA' && (
        <>
          <Grid xs={12} md={6}>
            <SelectInput
              name="state"
              values={formik.values.state}
              onChange={formik.handleChange}
              label="State/U.S. territory*"
              dataUp={`hs-state-${row}`}
              option={states}
              isMissing={!formik.values.state && check}
              disabled={disabled}
            />
          </Grid>
          <Grid xs={12} md={6}>
            <TextInput
              countText={50}
              logo="span-csu-logo"
              label="City*"
              name="csu_city"
              dataUp={`hs-city-${row}`}
              values={formik.values.csu_city}
              onChange={formik.handleChange}
              isMissing={!formik.values.csu_city && check}
              disabled={disabled}
            />
          </Grid>
        </>
      )}

      {/* Outside USA fields */}
      {formik.values.where_attend_high_school === 'OUTSIDE_USA' && (
        <>
          <Grid xs={12} md={6} className="pt-md-4 mt-11px">
            <AutocompleteInput
              className="d-flex flex-column justify-content-end"
              name="country"
              form={formik}
              values={formik.values.country}
              label="Select a country *"
              dataUp={`hs-country-${row}`}
              option={notUsCountry}
              isMissing={!formik.values.country && check}
              onChange={(e) => {
                try {
                  formik.handleChange(e);
                  formik.setFieldValue('high_school_object.country', e);
                }
                catch(ex){
                  console.log('Error:', ex);
                }
              }}
              disabled={disabled}
            />
          </Grid>
          <Grid xs={12} md={6} className="w34">
            <TextInput
              countText={49}
              logo="span-csu-logo"
              label="Academic Performance (High School GPA, Standing, Percentage, etc.)*"
              name="academic_performance"
              dataUp={`hs-academic-performance-${row}`}
              values={formik.values.academic_performance}
              onChange={formik.handleChange}
              isMissing={!formik.values.academic_performance && check}
              disabled={disabled}
            />
          </Grid>
          <Grid xs={12}>
            <TextInput
              countText={49}
              logo="span-csu-logo"
              label="Name of Degree/Diploma (e.g. Diploma, A-Level, Abitur, Certificado)*"
              name="name_of_degree"
              dataUp={`hs-degree-diploma-name-${row}`}
              values={formik.values.name_of_degree}
              onChange={formik.handleChange}
              isMissing={!formik.values.name_of_degree && check}
              disabled={disabled}
            />
          </Grid>
        </>
      )}

      {/* Specialized curriculum */}
      <Grid xs={12}>
        <div className="span-uc-logo">Specialized curriculum (only select if applicable to you)</div>
      </Grid>
      <Grid xs={12} md={6}>
        <CheckboxInput
          label="Home School"
          name="is_home_school"
          dataUp={`hs-home-school-${row}`}
          values={formik.values.is_home_school}
          onChange={formik.handleChange}
          disabled={disabled}
        />
      </Grid>
      <Grid xs={12} md={6}>
        <CheckboxInput
          label="Independent Study"
          name="is_independant_study"
          dataUp={`hs-independent-study-${row}`}
          values={formik.values.is_independant_study}
          onChange={formik.handleChange}
          disabled={disabled}
        />
      </Grid>

      {/* Home school additional fields */}
      {formik.values.is_home_school === true && (
        <>
          <Grid xs={12}>
            <CheckboxInput
              label="My home schooling curriculum is not associated with a high school."
              name="my_home_school_associated_with_high_school"
              dataUp={`hs-home-school-unassociated-${row}`}
              values={formik.values.my_home_school_associated_with_high_school}
              onChange={formik.handleChange}
              disabled={disabled}
            />
          </Grid>
          {formik.values.my_home_school_associated_with_high_school === true && (
            <>
              <Grid xs={12}>
                <div>Manualy Enter School Info</div>
              </Grid>
              <Grid xs={12} md={6}>
                <TextInput
                  name="school_name"
                  values={formik.values.school_name}
                  onChange={formik.handleChange}
                  label="School Name"
                  countText={36}
                  disabled={disabled}
                />
              </Grid>
              <Grid xs={12} md={6}>
                <TextInput
                  name="city"
                  values={formik.values.city}
                  onChange={formik.handleChange}
                  label="City"
                  countText={32}
                  disabled={disabled}
                />
              </Grid>
              <Grid xs={12}>
                <SelectInput
                  name="school_type"
                  values={formik.values.school_type}
                  onChange={formik.handleChange}
                  label="School Type"
                  option={['School Type*', 'Public', 'Private', 'Junior High']}
                  disabled={disabled}
                />
              </Grid>
            </>
          )}
        </>
      )}

      {/* High School Search */}
      <Grid xs={12}>
        <SelectSearchInput
          icon={<SearchIcon />}
          mdCol="12"
          form={formik}
          dataUp={`hs-school-search-${row}`}
          values={`${
            formik.values.high_school_object?.college_board_code ||
            formik.values.high_school_object?.school_name
              ? buildHighSchoolSearchLabel(formik.values.high_school_object, getStateName)
              : formik.values.high_school_name ?? ''
          }`}
          name="high_school_name"
          label={
            isFirstSchool ? 'Search for Current or Most Recent Secondary/High School' : 'Search for High School'
          }
          feedback="Search by CEEB code, City, County/Region/Territory, High School Name"
          option={highSchoolData}
          serverFiltered={true}
          onChangeItem={handleChangeItem}
          onSearch={(keyword: string) => {
            try {
              if (selectedEducation === undefined && !parseInt(keyword)) {
                if (keyword && keyword.length > 0) {
                  let newValues:any = Object.assign({}, formik.values);
                  newValues.high_school_name = keyword;
                  newValues.high_school_object.is_manual = true;
                  formik.setValues(newValues);
                  setHighSchoolName(keyword);
                  setEditMask(getEditMask(null));
                }
              }
              else {
                if (!parseInt(keyword)) {
                  setHighSchoolName(keyword);
                }
                setEditManual(false);
              }
              handleSearchHighSchool(keyword);
            }
            catch (ex) {
              console.log('Error: ', ex);
            }
          }}
          className='mt-4 mb-4'
          inputRef={typeahead}
          isLoading={loading}
          emptyLabel={(<></>)}
          disabled={disabled}
        />
      </Grid>

      {/* Not found message */}
      {showNotFound && (
        <Grid xs={12}>
          <div id="not-found" className="d-block not-found">
            <div className="text-center">
              <button type="button" className="btn-link btn-not-found" onClick={handleNotFound}>
                Desired high school, not found, I want to enter my high school manually
              </button>
            </div>
          </div>
        </Grid>
      )}

      {/* Selected High School Display */}
      <Grid xs={12}>
        <div className="my-2 text-field-light">Selected High School</div>
        {selectedEducation?.college_board_code && (
          <>
            <div className="d-flex align-items-end position-relative">
              <div className="mx-3 fw-bold">{displayHighSchoolName(selectedEducation)}</div>
              <span className="position-absolute h-100 d-flex align-items-center end-0">
                <RemoveIcon
                  fontSize="small"
                  className="bg-light text-dart rounded-circle mx-4 pointer"
                  onClick={handleRemove}
                  style={{
                    opacity: disabled ? 0.5 : 1,
                    cursor: disabled ? 'not-allowed' : 'pointer'
                  }}
                />
              </span>
            </div>
            <div className="d-block mx-3 pb-2">
              <div className="text-field-light sized70 pb-2">
                {`(code: ${selectedEducation?.college_board_code ?? ''}, city: ${selectedEducation?.city ?? ''
                  }, state: ${getStateName(selectedEducation?.state) ?? ''}, country: ${selectedEducation?.country ?? ''})`}
              </div>
            </div>
          </>
        )}
      </Grid>

      {/* Manual Edit Form */}
      {(highSchoolData !== undefined && !highSchoolData?.length) || (!formik.values.high_school_object?.match_all) || (formik.values.high_school_object?.match_all === false) ? (
        <>
          {editManual && checkEditMask() && (
            <Grid xs={12}>
              <div className="bg-light rounded p-3">
                <Grid container spacing={2}>
                  {/* High School Name - Full width */}
                  {editMask.school_name && (
                    <Grid xs={12}>
                      <TextInput
                        logo="span-uc-logo"
                        mdCol={12}
                        name="high_school_name"
                        values={highSchoolName}
                        onChange={(e) => {
                          try {
                            setHighSchoolName(e.target.value);
                            let newValues:any = Object.assign({}, formik.values);
                            newValues.high_school_object.school_name = e.target.value;
                            newValues.high_school_name = e.target.value;
                            newValues.school_name = e.target.value;
                            newValues.high_school_object.is_manual = true;
                            formik.setValues(newValues);
                          }
                          catch (ex) {
                            console.log('Error: ', ex);
                          }
                        }}
                        label="High School Name*"
                        countText={60}
                        isMissing={!formik.values.high_school_name && check}
                        disabled={disabled}
                      />
                    </Grid>
                  )}

                  {/* Dynamic fields container */}
                  <Grid container spacing={2} xs={12}>
                    {/* City */}
                    {editMask.city && (
                      <Grid xs={12} md={6}>
                        <TextInput
                          name="high_school_object.city"
                          values={formik.values.high_school_object?.city ?? ''}
                          onChange={(e: any) => {
                            formik.setFieldValue('high_school_object.city', e.target.value);
                          }}
                          label="City*"
                          countText={30}
                          isMissing={!formik.values.high_school_object?.city && check}
                          disabled={disabled}
                        />
                      </Grid>
                    )}

                    {/* School Type */}
                    {editMask.school_type && (
                      <Grid xs={12} md={6}>
                        <SelectInput
                          name="high_school_object.school_type"
                          values={formik.values.high_school_object?.school_type ?? ''}
                          onChange={(e: any) => {
                            formik.setFieldValue('high_school_object.school_type', e.target.value);
                          }}
                          label="School Type *"
                          option={highSchoolType}
                          isMissing={!formik.values.high_school_object?.school_type && check}
                          disabled={disabled}
                        />
                      </Grid>
                    )}

                    {/* Country */}
                    {editMask.country && (
                      <Grid xs={12} md={6}>
                        <AutocompleteInput
                          name="high_school_object.country"
                          form={formik}
                          defautlValues={formik.values.high_school_object?.country?.trim() ?? ''}
                          values={formik.values.high_school_object?.country?.trim() ?? ''}
                          label="Country"
                          option={csuCountry}
                          disabled={disabled}
                        />
                      </Grid>
                    )}

                    {/* State/Province based on country */}
                    {editMask.state && (
                      <>
                        {formik.values.high_school_object?.country === 'United States of America' ? (
                          <Grid xs={12} md={6}>
                            <AutocompleteInput
                              option={usaState}
                              form={formik}
                              label="State"
                              name="high_school_object.state"
                              values={getStateName(formik.values.high_school_object?.state)}
                              disabled={disabled}
                            />
                          </Grid>
                        ) : formik.values.high_school_object?.country === 'Canada' ? (
                          <Grid xs={12} md={6}>
                            <AutocompleteInput
                              form={formik}
                              option={canadaProvince}
                              label="Province"
                              name="high_school_object.province"
                              values={formik.values.high_school_object?.province}
                              disabled={disabled}
                            />
                          </Grid>
                        ) : (
                          <Grid xs={12} md={6}>
                            <TextInput
                              name="high_school_object.state_or_province"
                              values={formik.values.high_school_object?.state_or_province}
                              onChange={(e: any) => {
                                formik.setFieldValue('high_school_object.state_or_province', e.target.value);
                              }}
                              label="State or Province"
                              countText={30}
                              disabled={disabled}
                            />
                          </Grid>
                        )}
                      </>
                    )}

                    {/* Zip Code */}
                    {editMask.zip && (
                      <Grid xs={12} md={6}>
                        <TextInput
                          name="high_school_object.zip"
                          values={formik.values.high_school_object?.zip}
                          onChange={(e: any) => {
                            formik.setFieldValue('high_school_object.zip', e.target.value);
                          }}
                          label="Zip Code"
                          countText={10}
                          disabled={disabled}
                        />
                      </Grid>
                    )}

                    {/* College Board Code */}
                    {editMask.college_board_code && (
                      <Grid xs={12} md={6}>
                        <TextInput
                          name="high_school_object.college_board_code"
                          values={formik.values.high_school_object?.college_board_code}
                          onChange={(e: any) => {
                            let newValues:any = Object.assign({}, formik.values);
                            newValues.high_school_object.college_board_code = e.target.value;
                            newValues.high_school_code = e.target.value;
                            formik.setValues(newValues);
                          }}
                          label="College Board Code"
                          countText={10}
                          disabled={disabled}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </div>
            </Grid>
          )}
        </>
      ) : (<></>)}
      
      <style scoped>{`
div.w34 > div > div > label.select-label {
  width: calc(100% - 34px);
}
.mt-11px {
  margin-top: 11px;
}
button.btn-link.btn-not-found {
  color: #0d6efd!important;
  border: none!important;
  background: transparent;
  text-decoration: underline!important;
  text-decoration-color: #0d6efd!important;
  font-weight: 300;
  text-decoration-style: solid;
}
      `}</style>
    </Grid>
  );
};

export default HighSchoolInfo;
